import React from 'react'
import PropTypes from 'prop-types'
import GaugeLoadingState from '../LoadingState/GaugeLoadingState'

export const GaugeEmptyState = ({
  title = 'No Data available',
  subtitle,
  style = {},
  className = '',
  height,
  titleFontSize: _titleFontSize,
  subtitleFontSize: _subtitleFontSize
}) => {
  const titleFontSize = _titleFontSize ?? Math.max(height / 5, 16)
  const subtitleFontSize = _subtitleFontSize ?? Math.max(height / 10, 16)

  return (
    <div style={{ position: 'relative', ...style, height }} className={className}>
      <GaugeLoadingState animate={false} height={height} style={{ width: '100%' }} />
      <div className='absolute left-0 right-0 text-center' style={{ bottom: 10 }}>
        <p className='font-bold m-0 text-center' style={{ fontSize: titleFontSize, lineHeight: 0.9 }}>{title}</p>
        {subtitle?.length && (<p className='font-light m-0' style={{ fontSize: subtitleFontSize, lineHeight: 0.9 }}>{subtitle}</p>)}
      </div>
    </div>
  )
}

GaugeEmptyState.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  height: PropTypes.number,
  titleFontSize: PropTypes.number,
  subtitleFontSize: PropTypes.number
}

export default GaugeEmptyState
